import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=a08bd4ba&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a08bd4ba')) {
      api.createRecord('a08bd4ba', component.options)
    } else {
      api.reload('a08bd4ba', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=a08bd4ba&", function () {
      api.rerender('a08bd4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Qwj3gFBQBKot/JS/comp/ImageCarousel.vue"
export default component.exports